import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ATR } from "../directionalmovement/ATR";
import { Indicator, IndicatorInput } from "../indicator/indicator";
import LinkedList from "../Utils/FixedSizeLinkedList";
export var ChandelierExitInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(ChandelierExitInput, _IndicatorInput);

  function ChandelierExitInput() {
    var _this;

    _classCallCheck(this, ChandelierExitInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChandelierExitInput).apply(this, arguments));
    _this.period = 22;
    _this.multiplier = 3;
    return _this;
  }

  return ChandelierExitInput;
}(IndicatorInput);
export var ChandelierExitOutput =
/*#__PURE__*/
function (_IndicatorInput2) {
  _inherits(ChandelierExitOutput, _IndicatorInput2);

  function ChandelierExitOutput() {
    _classCallCheck(this, ChandelierExitOutput);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChandelierExitOutput).apply(this, arguments));
  }

  return ChandelierExitOutput;
}(IndicatorInput);
export var ChandelierExit =
/*#__PURE__*/
function (_Indicator) {
  _inherits(ChandelierExit, _Indicator);

  function ChandelierExit(input) {
    var _this2;

    _classCallCheck(this, ChandelierExit);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ChandelierExit).call(this, input));
    var highs = input.high;
    var lows = input.low;
    var closes = input.close;
    _this2.result = [];
    var atrProducer = new ATR({
      period: input.period,
      high: [],
      low: [],
      close: [],
      format: function format(v) {
        return v;
      }
    });
    var dataCollector = new LinkedList(input.period * 2, true, true, false);
    _this2.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var result, tick, atr, _tick, high, low;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return;

            case 2:
              tick = _context.sent;

            case 3:
              if (!true) {
                _context.next = 14;
                break;
              }

              _tick = tick, high = _tick.high, low = _tick.low;
              dataCollector.push(high);
              dataCollector.push(low);
              atr = atrProducer.nextValue(tick);

              if (dataCollector.totalPushed >= 2 * input.period && atr !== undefined) {
                result = {
                  exitLong: dataCollector.periodHigh - atr * input.multiplier,
                  exitShort: dataCollector.periodLow + atr * input.multiplier
                };
              }

              _context.next = 11;
              return result;

            case 11:
              tick = _context.sent;
              _context.next = 3;
              break;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this2.generator.next();

    highs.forEach(function (tickHigh, index) {
      var tickInput = {
        high: tickHigh,
        low: lows[index],
        close: closes[index]
      };

      var result = _this2.generator.next(tickInput);

      if (result.value !== undefined) {
        _this2.result.push(result.value);
      }
    });
    return _this2;
  }

  _createClass(ChandelierExit, [{
    key: "nextValue",
    value: function nextValue(price) {
      var result = this.generator.next(price);

      if (result.value !== undefined) {
        return result.value;
      }
    }
  }]);

  return ChandelierExit;
}(Indicator);
ChandelierExit.calculate = chandelierexit;
export function chandelierexit(input) {
  Indicator.reverseInputs(input);
  var result = new ChandelierExit(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}